import { PASSWORD_RECOVERY_COPY } from '../constants/passwordRecoveryContent'

export default function AuthRecoveryTopBar() {
  return (
    <header className="sticky top-0 z-20 flex w-full items-center justify-between bg-surface px-8 py-4">
      <div className="font-display text-[42px] font-extrabold tracking-tight text-primary">
        {PASSWORD_RECOVERY_COPY.brand}
      </div>

      <button
        type="button"
        className="inline-flex h-9 w-9 items-center justify-center rounded-full text-secondary transition hover:bg-surface-container-low"
        aria-label="Help"
      >
        <span className="material-symbols-outlined text-[22px]">help</span>
      </button>
    </header>
  )
}
